<h1 mat-dialog-title>{{ langListLabel() }}</h1>
<mat-dialog-content>
  <mulo-language-select></mulo-language-select>
</mat-dialog-content>
<mat-dialog-actions class="padding-bottom-sm">
  <span class="action-spacer"></span>
  <button mat-button mat-dialog-close>{{ cancelLabel() }}</button>
</mat-dialog-actions>
